module.exports = __webpack_public_path__ + "img/fine2.de1f7759.jpg";